import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { RevealOnScroll } from "./RevealText";
import { whatsappUrl } from "../../lib/leads";

const AREAS = [
  "Jodhpur", "Jaipur", "Pali", "Bikaner", "Udaipur", "Barmer", "Jaisalmer",
  "Falna", "Sumerpur", "Mount Abu", "Nakoda Ji", "Osian", "Balotra", "Pachpadra",
  "Pushkar", "Jalore", "Ajmer", "Sikar", "Ramdevra", "Sri Ganganagar", "Sirohi",
  "Sawai Madhopur", "Rajsamand", "Pratapgarh", "Kota", "Karauli", "Jhunjhunu",
  "Jhalawar", "Dholpur", "Dungarpur", "Hanumangarh", "Dausa", "Bundi",
  "Chittorgarh", "Churu", "Baran", "Banswara", "Tonk", "Nagaur",
];

export const ServiceAreas = () => {
  return (
    <section id="areas" data-testid="areas-section" className="relative bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <RevealOnScroll>
          <span className="text-xs uppercase tracking-[0.3em] text-jodhpur-accent font-semibold">Service Areas</span>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-jodhpur-primary tracking-tight max-w-2xl">
            Taxi service across <span className="italic">Rajasthan</span> & beyond
          </h2>
          <p className="mt-5 max-w-2xl text-jodhpur-ink/65 leading-relaxed">
            Reliable one-way and round-trip cabs to and from every major town and pilgrimage in Rajasthan. Tap a city to book instantly on WhatsApp.
          </p>
        </RevealOnScroll>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          variants={{ show: { transition: { staggerChildren: 0.02 } } }}
          className="mt-12 flex flex-wrap gap-2.5"
        >
          {AREAS.map((city) => (
            <motion.a
              key={city}
              href={whatsappUrl(`Namaste! I need a taxi in ${city}.`)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`area-${city}`}
              variants={{ hidden: { opacity: 0, y: 12 }, show: { opacity: 1, y: 0 } }}
              className="group inline-flex items-center gap-1.5 rounded-full border border-jodhpur-primary/15 bg-jodhpur-bg px-4 py-2 text-sm font-medium text-jodhpur-ink/80 transition-all duration-300 hover:border-jodhpur-secondary hover:bg-jodhpur-primary hover:text-white"
            >
              <MapPin className="h-3.5 w-3.5 text-jodhpur-accent group-hover:text-white" />
              Taxi in {city}
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
